import { z } from "zod";

import { LanguageCodes, VoiceLlm } from "Infrastructure/Api/Api";
import {
  getTranslation,
  Resources,
} from "Infrastructure/Translations/Resources";

export const createVoiceFormSchema = z.object({
  name: z
    .string()
    .min(1, { error: () => getTranslation(Resources.Validation.Required) })
    .max(256),
  tags: z.string().max(256).optional().nullable(),
  voiceLlm: z.enum(VoiceLlm, {
    error: () => getTranslation(Resources.Validation.Required),
  }),
  language: z.enum(LanguageCodes, {
    error: () => getTranslation(Resources.Validation.Required),
  }),
  externalVoiceID: z.string().max(1024).optional().nullable(),
  externalEndpoint: z.string().max(1024).optional().nullable(),
});

export type CreateVoiceFormData = z.infer<typeof createVoiceFormSchema>;

export const editVoiceFormSchema = z.object({
  name: z
    .string()
    .min(1, { error: () => getTranslation(Resources.Validation.Required) })
    .max(256),
  tags: z.string().max(256).optional().nullable(),
  language: z.enum(LanguageCodes, {
    error: () => getTranslation(Resources.Validation.Required),
  }),
  externalEndpoint: z.string().max(1024).optional().nullable(),
});

export type EditVoiceFormData = z.infer<typeof editVoiceFormSchema>;
